import { createTheme } from "@mui/material";
import { palette } from "./palette";

const baseTheme = createTheme({
  palette,
});

export { baseTheme };
